import { merchantApi } from '@/config/axios'

export interface PortalSubmission {
  username: string
  companyName?: string
  tel: string
  email?: string
  address?: string
  content?: string
  productName?: string
  buyNum?: number
  type: string
}

export interface PortalArticle {
  id: number | string
  categoryId: number | string
  title: string
  shortTitle?: string
  summary?: string
  content?: string
  coverImage?: string
  linkUrl?: string
  publishTime?: string
  sort?: number
  extra?: string
  isRecommend?: number
  author?: string
  source?: string
  hits?: number
}

export interface PortalCategory {
  id: number
  parentId?: number
  name: string
  alias?: string
  description?: string
  icon?: string
  imageUrl?: string
}

export interface PortalJob {
  id: number | string
  title: string
  department?: string
  workAddress?: string
  workYears?: string
  education?: string
  salary?: string
  content?: string
  seoDescription?: string
}

const publicHeaders = { isToken: false }

export const submitPortalMessage = (data: PortalSubmission) =>
  merchantApi.post<number>({ url: '/app-api/cms/message/submit', data, headers: publicHeaders })

export const getPortalSite = () =>
  merchantApi.get({ url: '/app-api/cms/site/current', headers: publicHeaders })

export const getPortalSiteConfig = () =>
  merchantApi.get({ url: '/app-api/cms/site-config/site-config', headers: publicHeaders })

export const getPortalArticles = (params?: {
  siteId?: number
  categoryId?: number
  pageNo?: number
  pageSize?: number
}) =>
  merchantApi.get<{ list: PortalArticle[]; total: number }>({
    url: '/app-api/cms/article/page',
    params: { pageNo: 1, pageSize: 100, ...params },
    headers: publicHeaders
  })

export const getPortalCategories = (params?: { siteId?: number }) =>
  merchantApi.get<PortalCategory[]>({
    url: '/app-api/cms/category/list',
    params,
    headers: publicHeaders
  })

export async function getPortalArticlesByCategory(alias: string) {
  const categories = await getPortalCategories()
  const category = categories.find((item) => item.alias === alias || item.name === alias)
  if (!category) return []
  const page = await getPortalArticles({ categoryId: category.id })
  return page.list || []
}

export const getPortalArticle = (id: number | string) =>
  merchantApi.get<PortalArticle>({
    url: `/app-api/cms/article/detail/${id}`,
    headers: publicHeaders
  })

export const getPortalRelatedArticles = (id: number | string, siteId?: number) =>
  merchantApi.get<PortalArticle[]>({
    url: `/app-api/cms/article/related/${id}`,
    params: siteId != null ? { siteId } : undefined,
    headers: publicHeaders
  })

export const getPortalJobs = () =>
  merchantApi.get<{ list: PortalJob[]; total: number }>({
    url: '/app-api/cms/job/page',
    headers: publicHeaders
  })

export const getPortalJob = (id: number | string) =>
  merchantApi.get<PortalJob>({ url: `/app-api/cms/job/detail/${id}`, headers: publicHeaders })

export const getPortalFaqs = () =>
  merchantApi.get({ url: '/app-api/cms/faq/list', headers: publicHeaders })

export const getPortalBanners = (position = 'portal_home') =>
  merchantApi.get({
    url: '/app-api/cms/banner/list',
    params: { position },
    headers: publicHeaders
  })

export const getPortalNavMenus = (typeName = 'portal_top') =>
  merchantApi.get({
    url: '/app-api/cms/nav-menu/list',
    params: { typeName },
    headers: publicHeaders
  })
